'use client';

import { useEffect } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import type { LangCode } from '@/lib/i18n/lang';

export function LangFromParams({ lang }: { lang: LangCode }) {
  const { setLang } = useLanguage();

  useEffect(() => {
    setLang(lang);
  }, [lang, setLang]);

  return null;
}
